import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=463daa62"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports